import React from 'react';
import '../styles/pages/Industries.css';
import '../styles/GlobalSections.css';

const industries = [
  {
    title: 'Banks',
    description: 'Comprehensive KYC verification solutions for banking institutions',
    icon: '🏦'
  },
  {
    title: 'NBFCs',
    description: 'Tailored KYC assessment services for Non-Banking Financial Companies',
    icon: '💼'
  },
  {
    title: 'Microfinance',
    description: 'Empowering microfinance institutions with accurate KYC verification',
    icon: '🤝'
  },
  {
    title: 'Co-operative Credit Society',
    description: 'Supporting cooperative societies with reliable KYC verification',
    icon: '👥'
  },
  {
    title: 'Multi State Co-operative Credit Society',
    description: 'Pan-India KYC solutions for multi-state cooperative societies',
    icon: '🏛️'
  },
  {
    title: 'Nidhi Company',
    description: 'KYC verification services for Nidhi companies',
    icon: '📊'
  },
  {
    title: 'Fintech',
    description: 'Advanced KYC APIs and solutions for fintech companies',
    icon: '💡'
  },
  {
    title: 'Insurance',
    description: 'Risk assessment and KYC verification for insurance sector',
    icon: '🛡️'
  },
  {
    title: 'Healthcare',
    description: 'Medical financing and KYC verification solutions for healthcare providers',
    icon: '🏥'
  },
  {
    title: 'Mortgage',
    description: 'Property loan KYC verification services',
    icon: '🏠'
  },
  {
    title: 'Alternative Financial Services',
    description: 'Innovative KYC verification solutions for alternative lending platforms',
    icon: '💳'
  }
];

export default function Industries() {
  return (
    <div className="industries-page">
      <section className="industries-hero">
        <div className="container">
          <h1>Industries We Serve</h1>
          <p>Empowering financial institutions across sectors with reliable KYC information</p>
        </div>
      </section>

      <section className="industries-grid-section section-white">
        <div className="container">
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-card">
                <div className="industry-icon">{industry.icon}</div>
                <h3>{industry.title}</h3>
                <p>{industry.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="industries-cta section-light-blue">
        <div className="container">
          <h2>Ready to Transform Your KYC Assessment?</h2>
          <p>Join thousands of financial institutions trusting LCS for accurate KYC Verification</p>
          <button className="btn-primary" onClick={() => window.location.href = '/contact'}>
            Get Started
          </button>
        </div>
      </section>
    </div>
  );
}
